import api from '@/utils/api';
import { traditionalGet, traditionalPost, traditionalPut } from '@/utils/api-helpers/traditionalApiHelper';
import apiInventry from '@/utils/api-inventry';
import { handleErrorResponse, handleResponse } from '@/utils/common/common';
import { ApiErrorResponse } from '@/utils/types/common';
import {
  EditUserRequest,
  EditUserResponse,
  GetUserListAllResponse,
  GetUserListResponse,
  ImpersonateLogoutUserResponse,
  ImpersonateUserResponse,
} from '@/utils/types/user';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const getUserList = async (
  search: string,
  pageNo: number,
  limit: number,
  sortBy: string,
  order: string,
): Promise<GetUserListResponse | ApiErrorResponse> => {
  return traditionalGet<GetUserListResponse>({
    api,
    endpoint: '/users',
    params: {
      search,
      page: pageNo,
      limit,
      sortBy,
      order,
    },
  });
};

export const editUser = async (
  id: string,
  editUserRequest: Partial<EditUserRequest>,
): Promise<EditUserResponse | ApiErrorResponse> => {
  return traditionalPut<EditUserResponse, Partial<EditUserRequest>>({
    api,
    endpoint: `/users/${id}`,
    data: editUserRequest,
  });
};

export const usePingUsers = () => {
  return useQuery({
    queryKey: ['ping-users'],
    queryFn: async () => {
      try {
        const response = await apiInventry.get<GetUserListAllResponse>('/users');
        return handleResponse(response);
      } catch (error) {
        if (axios.isAxiosError(error)) throw handleErrorResponse(error);
        throw error;
      }
    },
    refetchIntervalInBackground: true,
    refetchInterval: 5 * 60 * 1000, // 2 minutes
    retry: true,
    refetchOnWindowFocus: false, // optional: don't trigger on window refocus
  });
};
export const impersonateUser = async (userId: number): Promise<ImpersonateUserResponse | ApiErrorResponse> => {
  return traditionalPost<ImpersonateUserResponse, { userId: number }>({
    api,
    endpoint: 'users/impersonation/login',
    data: { userId },
  });
};
export const logoutImpersonateUser = async (): Promise<ImpersonateLogoutUserResponse | ApiErrorResponse> => {
  return traditionalPost<ImpersonateLogoutUserResponse>({
    api,
    endpoint: 'logout',
  });
};
